var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.suppliers),function(supplier,idx){return _c('span',{key:supplier.id},[_c('router-link',{attrs:{"to":{ name: 'View Supplier', params: { id: supplier.id } }}},[_vm._v(" "+_vm._s(`${supplier.company_name}`)+" ")]),_vm._v(" "+_vm._s(_vm.suppliers?.length - 1 > idx ? "," : " ")),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }